import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicyView from "@/components/views/PrivacyPolicy/privacy-policy.view";

export const Route = createFileRoute("/privacy-policy")({
    component: RouteComponent,
});

function RouteComponent() {
    return <PrivacyPolicyView />;
}
